let map;
let markers = [];
let stores = [];
let geocoder;
let userMarker = null;
let infoWindow = null;
let activeStoreId = null;

async function loadStores() {
  stores = (window.storeLocations || [])
    .map((store, index) => ({
      ...store,
      id: index,
      lat: parseFloat(store.lat),
      lng: parseFloat(store.lng)
    }))
    .filter((store) => !Number.isNaN(store.lat) && !Number.isNaN(store.lng));
}

function clearMarkers() {
  markers.forEach((item) => item.marker.setMap(null));
  markers = [];

  if (userMarker) {
    userMarker.setMap(null);
    userMarker = null;
  }
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function setActiveCard(storeId) {
  activeStoreId = storeId;

  document.querySelectorAll('.store-card').forEach((card) => {
    const isActive = Number(card.dataset.storeId) === Number(storeId);
    card.classList.toggle('is-active', isActive);
  });
}

function focusStore(storeId, openInfo = true) {
  const entry = markers.find((item) => item.store.id === storeId);
  if (!entry) return;

  const { marker, store } = entry;

  map.panTo({ lat: store.lat, lng: store.lng });
  map.setZoom(Math.max(map.getZoom() || 6, 9));

  setActiveCard(storeId);

  
if (openInfo && infoWindow) {
  const link = String(store.lien || '').trim();
  const hasValidLink = /^https?:\/\//i.test(link);

  infoWindow.setContent(`
    <div style="min-width:220px;padding:4px 2px;">
      <strong style="display:block;font-size:15px;margin-bottom:6px;">
        ${escapeHtml(store.name)}
      </strong>

      <div style="font-size:13px;line-height:1.5;color:#5f6672;">
        ${escapeHtml(store.address || '')}
      </div>

      ${store.zip
        ? `<div style="font-size:13px;margin-top:4px;">
             Code postal: ${escapeHtml(store.zip)}
           </div>`
        : ''
      }

      ${hasValidLink
        ? `
          <a
            href="${escapeHtml(link)}"
            target="_blank"
            rel="noopener noreferrer"
            style="display:inline-block;margin-top:12px;color:#111;text-decoration:underline;font-weight:600;"
          >
            En savoir plus →
          </a>
        `
        : ''
      }
    </div>
  `);

  infoWindow.open({
    anchor: marker,
    map
  });
}


  const activeCard = document.querySelector(`.store-card[data-store-id="${storeId}"]`);
  if (activeCard) {
    activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}


function renderList(storeList) {
  const container = document.getElementById('store-results');
  if (!container) return;

  container.innerHTML = '';

  if (!storeList.length) {
    container.innerHTML = `
      <div class="store-empty">
        Aucun revendeur trouvé.
      </div>
    `;
    return;
  }

  storeList.forEach((store) => {
    const card = document.createElement('article');
    card.className = 'store-card';
    card.dataset.storeId = store.id;

    const link = String(store.lien || '').trim();
    const hasValidLink = /^https?:\/\//i.test(link);

    card.innerHTML = `
      <h3>${escapeHtml(store.name)}</h3>

      <p>${escapeHtml(store.address || '')}</p>

      ${store.zip
        ? `<p>Code postal: ${escapeHtml(store.zip)}</p>`
        : ''
      }

      ${store.distance !== undefined
        ? `<p>Distance: ${store.distance.toFixed(1)} km</p>`
        : ''
      }

      ${hasValidLink
        ? `
          <a
            href="${escapeHtml(link)}"
            class="store-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            En savoir plus
          </a>
        `
        : ''
      }
    `;

    card.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        return;
      }

      focusStore(store.id, true);
    });

    container.appendChild(card);
  });

  if (storeList[0]) {
    setActiveCard(storeList[0].id);
  }
}


function haversineDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function addMarkers(storeList, userLocation = null) {
  clearMarkers();

  const bounds = new google.maps.LatLngBounds();

  if (userLocation) {
    userMarker = new google.maps.Marker({
      map,
      position: userLocation,
      title: 'Votre position',
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: '#1f2430',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      }
    });

    bounds.extend(userLocation);
  }

  storeList.forEach((store) => {
    const marker = new google.maps.Marker({
      map,
      position: { lat: store.lat, lng: store.lng },
      title: store.name,
      icon: {
        url:
          'data:image/svg+xml;utf-8,' +
          encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42">
              <path fill="#ef4444" d="M15 0C7.268 0 1 6.268 1 14c0 10.26 14 28 14 28s14-17.74 14-28C29 6.268 22.732 0 15 0z"/>
              <circle cx="15" cy="14" r="5.5" fill="white"/>
            </svg>
          `),
        scaledSize: new google.maps.Size(30, 42)
      }
    });

    marker.addListener('click', () => {
      focusStore(store.id, true);
    });

    markers.push({ marker, store });
    bounds.extend({ lat: store.lat, lng: store.lng });
  });

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
      if (map.getZoom() > 12) {
        map.setZoom(12);
      }
    });
  }
}

function geocodeZip(zip) {
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: zip }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        resolve({
          lat: location.lat(),
          lng: location.lng()
        });
      } else {
        reject(new Error(`Échec du géocodage: ${status}`));
      }
    });
  });
}

window.initMap = async function () {
  const mapEl = document.getElementById('store-map');
  if (!mapEl) return;

  await loadStores();

  map = new google.maps.Map(mapEl, {
    center: { lat: 46.2276, lng: 2.2137 },
    zoom: 6,
    mapTypeControl: true,
    streetViewControl: false,
    fullscreenControl: true,
    styles: [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      }
    ]
  });

  geocoder = new google.maps.Geocoder();
  infoWindow = new google.maps.InfoWindow();

  renderList(stores);
  addMarkers(stores);

  const form = document.getElementById('store-locator-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const input = document.getElementById('zip-input');
    if (!input) return;

    const zip = input.value.trim();

    if (!zip) {
      renderList(stores);
      addMarkers(stores);
      if (stores[0]) focusStore(stores[0].id, false);
      return;
    }

    try {
      const userLocation = await geocodeZip(zip);

      const nearby = stores
        .map((store) => ({
          ...store,
          distance: haversineDistance(
            userLocation.lat,
            userLocation.lng,
            store.lat,
            store.lng
          )
        }))
        .sort((a, b) => a.distance - b.distance);

      renderList(nearby);
      addMarkers(nearby, userLocation);

      if (nearby[0]) {
        focusStore(nearby[0].id, true);
      }
    } catch (error) {
      console.error(error);
      alert('Le code postal indiqué est introuvable.');
    }
  });
};